module.exports = __webpack_public_path__ + "img/case15.172a380e.png";